// extracted by mini-css-extract-plugin
export default {"root":"Header_root__KHmDZ","title":"Header_title__Xe+oh","subTitle":"Header_subTitle__U1Nir"};